import React from 'react';
import { Select, Divider, List, Col, Row } from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet } from '../../actions';
import PlaylistTableView from '../views/PlaylistTableView';
import Column from 'antd/lib/table/Column';
import ActionButton from '../ActionButton';
import "./PlaylistSelectorPopup.css";
import PopupManager from '../../managers/PopupManager';
import DataHelper from '../../helpers/DataHelper';

const { Option } = Select;

class PlaylistSelectorPopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = { playlistDatas: [], newPlaylistName: "" }
    }

    componentDidMount() {
        this.reloadPlaylists();
    }

    reloadPlaylists = () => {

        const { brandid } = this.props;

        DataHelper.getPlaylists({ brandid: brandid }, this.props).then((data) => {
            this.setState({ playlistDatas: data })
        })
    }

    filter = (inputValue, path) => {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }

    onChange = (value, selectedOptions) => {
        const { onChange } = this.props;
        onChange(value, selectedOptions);
    }

    onNameChange = event => {
        this.setState({
            newPlaylistName: event.target.value,
        });
    };

    renderList = () => {

        const { onItemSelected = () => { } } = this.props
        return (
            <List
                size="medium"
                header={<div>Select Playlist</div>}
                footer={<div></div>}
                bordered
                dataSource={this.state.playlistDatas}
                renderItem={item =>
                    <div onClick={() => {
                        onItemSelected(item)
                        PopupManager.closePopup();
                    }} className="center-content playlist-choice" style={{ padding: "2px", border: "1px solid #f0f0f0", borderRadius: "4px" }}>
                        <Row align="middle" justify="space-between" gutter={[4, 0]} style={{ width: "95%", height: "30px", cursor: "pointer" }}>
                            <Col span={20}><img style={{ width: "20px", height: "20px", marginRight: "16px" }} src="/cms/assets/svgs/icons/playlist_icon.svg"></img>{item.PlaylistName}</Col>
                            <Col span={4} style={{}}> <div>
                                <img src="/cms/assets/svgs/icons/darkfolder_icon.svg" style={{ width: "12px", height: "12px", display: "inline-block", marginRight: "16px", objectFit: "contain" }}></img>
                                {item.Medias ? item.Medias.length : 0}
                            </div>
                            </Col>
                            {/* <Col span={4} >
                                <div style={{ marginLeft: "-10px" }}>

                                    <ActionButton confirmText="Are you sure you want to delete this playlist?" onClicked={() => onDelete(index)} title="Delete" showTitle={false} icon="/cms/assets/svgs/icons/trash_icon.svg"></ActionButton>
                        <ActionButton onClicked={() => onEdit(index)} title="Edit" showTitle={false} icon="/cms/assets/svgs/icons/edit_icon.svg"></ActionButton>
                        <ActionButton onClicked={() => onDuplicate(index)} title="Duplicate" showTitle={false} icon="/cms/assets/svgs/icons/duplicate_icon.svg"></ActionButton>
                                </div>
                            </Col> */}
                        </ Row>
                    </div>}
            />
        )
    }

    render() {
        const { requestServerPost, usertoken } = this.props;
        return (
            // <Cascader
            //     options={this.state.playlistOptions}
            //     onChange={this.onChange}
            //     placeholder="Select Playlist"
            //     showSearch={this.filter}
            // />

            <>{this.renderList()}</>

        )
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage, requestNodeServerPost })(PlaylistSelectorPopup);